import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { FETCH_STATUSES } from 'resources'

import actions from './actions'
import { setFullUnveilConflictFirstOptions } from './utils'

const initialState = {
  attributesCount: 0,
  profileRewardsQuestions: null,
  fetchStatus: FETCH_STATUSES.NOOP,
  fullUnveil: null,
  breachData: null,
}

const reducer = (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case actions.fetchProfileRewardsData.INIT_TYPE: {
      return {
        ...state,
        fetchStatus: FETCH_STATUSES.FETCHING,
      }
    }
    case actions.fetchProfileRewardsData.SUCCESS_TYPE: {
      const { attributesCount, questions } = payload
      return {
        ...state,
        fetchStatus: FETCH_STATUSES.SUCCESS,
        attributesCount,
        profileRewardsQuestions: questions,
      }
    }
    case actions.fetchProfileRewardsData.FAILURE_TYPE: {
      return {
        ...state,
        fetchStatus: FETCH_STATUSES.FAILURE,
      }
    }
    case actions.updateProfileRewardsAnswer.SUCCESS_TYPE: {
      const { question } = payload
      return {
        ...state,
        profileRewardsQuestions: state.profileRewardsQuestions.map((q) => (q.id === question.id ? question : q)),
      }
    }
    case actions.fetchFullUnveil.SUCCESS_TYPE: {
      const { questions, attributesCount, profilesCount, associatedIds, conflicts, breachData } = payload
      return {
        ...state,
        fullUnveil: {
          attributesCount,
          profilesCount,
          questions,
          associatedIds,
          conflicts: setFullUnveilConflictFirstOptions(conflicts),
          breachData,
          isAssociatedIdsHandled: false,
        },
      }
    }
    case actions.setFullUnveilConflictSelectedOption.SUCCESS_TYPE: {
      if (!state?.fullUnveil?.conflicts) {
        return state
      }
      const { conflicts } = state.fullUnveil
      const { questionIndex, selectedOptionIndex } = payload
      return {
        ...state,
        fullUnveil: {
          ...state.fullUnveil,
          conflicts: [
            ...conflicts.slice(0, questionIndex),
            {
              ...conflicts[questionIndex],
              selectedOptionIndex,
            },
            ...conflicts.slice(questionIndex + 1),
          ],
        },
      }
    }
    case actions.resetFullUnveil.SUCCESS_TYPE: {
      return {
        ...state,
        fullUnveil: null,
      }
    }
    case actions.toggleAssociatedIdIsHidden.SUCCESS_TYPE: {
      if (!state?.fullUnveil?.associatedIds) {
        return state
      }
      const { associatedIds } = state.fullUnveil
      const { associatedIdIndex } = payload
      return {
        ...state,
        fullUnveil: {
          ...state.fullUnveil,
          associatedIds: [
            ...associatedIds.slice(0, associatedIdIndex),
            {
              ...associatedIds[associatedIdIndex],
              isHidden: !associatedIds[associatedIdIndex].isHidden,
            },
            ...associatedIds.slice(associatedIdIndex + 1),
          ],
        },
      }
    }
    case actions.updateAssociatedIds.SUCCESS_TYPE: {
      return {
        ...state,
        fullUnveil: {
          ...state.fullUnveil,
          isAssociatedIdsHandled: true,
        },
      }
    }
    case actions.fetchBreachData.FAILURE_TYPE: {
      return {
        ...state,
        breachData: null,
      }
    }
    case actions.fetchBreachData.SUCCESS_TYPE: {
      const {
        breachesCount,
        passwordsCount,
        breachesAttributesCount,
        isDataBreachesScanned,
        isProspectDataBreachesScanned,
        isProspectDataBreachesFound,
        idBreaches,
      } = payload
      return {
        ...state,
        breachData: {
          breachesCount,
          passwordsCount,
          breachesAttributesCount,
          isDataBreachesScanned,
          isProspectDataBreachesScanned,
          isProspectDataBreachesFound,
          idBreaches,
        },
      }
    }
    case 'RESET': {
      return initialState
    }
    default:
      return state
  }
}

const persistConfig = {
  key: 'profileRewards',
  storage,
}

export default persistReducer(persistConfig, reducer)
